import {
    Optional,
    Provider,
    SkipSelf,
    NgZone

} from '@angular/core';

import {
    MatSnackBar,
} from '@angular/material/snack-bar';

import {
    Directionality,
} from '@angular/cdk/bidi';

import {
    Store,
} from '@ngxs/store';

import {
    NotificationCenter,
} from './services/notification.service';


export const notificationServiceFactory = (
    service: NotificationCenter,
    store: Store,
    snackbar: MatSnackBar,
    dir: Directionality,
    zone:NgZone
) => {
    return service || new NotificationCenter(snackbar, dir, store,zone);
};

export const notificationProvider: Provider = {
    provide: NotificationCenter,
    useFactory: notificationServiceFactory,
    deps: [
        [new Optional(), new SkipSelf(), NotificationCenter],
        [Store],
        [MatSnackBar],
        [Directionality],
        [NgZone]
    ],
};
